var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$meta.features.owners.workflows)?_c('PropertyWorkflows'):_vm._e(),_vm._v(" "),(_vm.$meta.portfolio_details_tab_text)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.$meta.portfolio_details_tab_text)}}):_c('PortfolioKeyDates')],1)}
var staticRenderFns = []

export { render, staticRenderFns }